/**
 * Format HH:mm (24h) to 12-hour AM/PM for display.
 * e.g. "09:00" → "9:00 AM", "17:00" → "5:00 PM", "12:00" → "12:00 PM"
 */
export function formatHHmmToAmPm(hhmm) {
  if (!hhmm || typeof hhmm !== 'string') return '';
  const parts = hhmm.trim().split(':').map(Number);
  const h = parts[0];
  const m = Number.isNaN(parts[1]) ? 0 : parts[1];
  if (Number.isNaN(h)) return hhmm;
  const period = h === 0 ? 'AM' : h < 12 ? 'AM' : 'PM';
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
}

export function formatDecimalHours(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0h';
  const totalMinutes = Math.max(0, Math.round(n * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
}

/**
 * Insert spaces before uppercase letters (except first char):
 * "AlessandroSpegn" -> "Alessandro Spegn"
 */
export function formatDisplayName(name) {
  if (name == null) return '';
  const raw = String(name);
  if (!raw) return '';
  return raw.replace(/([A-Z])/g, (match, _cap, offset, whole) => {
    if (offset === 0) return match;
    return whole[offset - 1] === ' ' ? match : ` ${match}`;
  }).trim();
}
